import { addDays, startOfDay } from 'date-fns';
import { TZDate } from '@date-fns/tz';

export type DateRange = { start: Date; end: Date };

/**
 * Represents a date range that starts at the beginning of the previous day and ends at the beginning of the current day.
 */
export class PreviousDayDateRange implements DateRange {
  public readonly start: Date;
  public readonly end: Date;

  /**
   * Creates a date range that starts at the beginning of the previous day and ends at the beginning of the current day.
   * @param date the date to calculate the previous day for
   * @param timeZone the time zone to calculate the previous day in
   */
  constructor(date: Date, timeZone?: string) {
    const endTzDate = startOfDay(
      // If a timezone is provided, use it to create a TZDate with the provided timezone, otherwise use the date as is
      timeZone ? new TZDate(date, timeZone) : date,
    );
    const startTzDate = addDays(endTzDate, -1);

    this.end = new Date(endTzDate);
    this.start = new Date(startTzDate);
  }
}
